
import { useContext, useMemo, useState, useEffect, useRef } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./PreDehydCooler.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import { simulateCooler } from "../processEngines/CoolerEngine";
import SingleStageCompressorFaceplate from "../components/SingleStageCompressor/SingleStageCompressorFaceplate";
import {simulateSingleStageCompressor, startCompressor, stopCompressor, updateCompressor, createCompressorState} from "../components/SingleStageCompressor/SingleStageCompressorEngine";
import CompressorTrendFaceplate from "../components/SingleStageCompressor/CompressorTrendFaceplate";
import { CompressorContext } from "../context/CompressorContext";

import { trackPageVisit } from "../competency/PageTracker";





 
      /*  CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function PreDehydCooler() {

        useEffect(() => {
  
    trackPageVisit("PreDehydCooler");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);
    const [showTrend, setShowTrend] = useState(false);
    
    
    
const { compressorE, CompressorTrendFaceplate } = useContext(CompressorContext);

const compressor = compressorE; // or A depending on page
    

    const [open, setOpen] = useState(false);
    // ======================================
    // FORCE UI REFRESH FOR COMPRESSOR STATE
    // ======================================

    const [, forceRender] = useState(0);

    useEffect(() => {

      const interval = setInterval(() => {

        forceRender(v => v + 1);

      }, 100);

      return () => clearInterval(interval);

    }, []);

    

    

  const DEFAULT_VALVES = {
  FCV_4201: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("PreDehydCooler_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_4201: { ...DEFAULT_VALVES.FCV_4201, ...parsed.FCV_4201 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("PreDehydCooler_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO LP COMPRESSOR =================

  const [FIC_2104, setFIC_2104] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2104")) || 0;
            setFIC_2104(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2102, setPT_2102] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2102")) || 0;
            setPT_2102(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_2102, setTT_2102] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_2102")) || 0;
            setTT_2102(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_21011, setPT_21011] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_21011")) || 0;
            setPT_21011(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);



  /* ================= VALVE STATUS ================= */

  const isXV4201Open = valves?.XV_4201 === false;
  const isXV4202Open = valves?.XV_4202 === false;
  const isXV4203Open = valves?.XV_4203 === false;


    const FIC_4201 = isXV4201Open ? FIC_2104 : 0;
    const PT_4201 = isXV4201Open ? PT_2102 +  PT_21011: 0.03;
    const TT_4201 = isXV4201Open ? TT_2102 : 24;

    const FIC_4203 = isXV4202Open ? 30.24 : 0;
    const TT_4203 = isXV4202Open ? 24 : 28;
    const PT_4203 = isXV4202Open ? 1.3 : 0.03;



    // ======================================================
    // PRE-GAS SWEETENING COOLER
    // ======================================================

    // ======================================================
    // COOLER OUTPUT VARIABLES
    // ======================================================

    let FIC_4202 = 0;
    let PT_4202 = 0;
    let TT_4202 = 25;

    let FIC_4204 = 0;
    let PT_4204 = 0;
    let TT_4204 = 25;

    // ======================================================
    // EFFECTIVE GAS FLOW
    // FCV_4201 affects exchanger duty
    // Lower opening = lower gas flow
    // Better residence time = better cooling
    // ======================================================

    const FIC_4201_EFFECTIVE =
    isXV4201Open
        ? FIC_4201 *
        ((valveData?.FCV_4201?.opening || 0) / 100)
        : 0;

    // ======================================================
    // CASE 1
    // GAS VALVE CLOSED
    // ======================================================

    if (!isXV4201Open) {

    // =========================
    // GAS SIDE
    // =========================

    FIC_4202 = 0;

    PT_4202 = 0;

    TT_4202 = 25;

    // =========================
    // WATER SIDE
    // =========================

    FIC_4204 = 0;

    PT_4204 = 0;

    TT_4204 = TT_4203;
    }

    // ======================================================
    // CASE 2
    // GAS FLOWING BUT NO WATER FLOW
    // ======================================================

    else if (!isXV4202Open) {

    // =========================
    // NO HEAT EXCHANGE
    // =========================

    FIC_4202 =
        FIC_4201_EFFECTIVE * 0.995;

    PT_4202 =
        PT_4201 * 0.98;

    // GAS PASSES THROUGH HOT
    TT_4202 =
        TT_4201;

    // =========================
    // WATER STATIC
    // =========================

    FIC_4204 = 0;

    PT_4204 = 0;

    TT_4204 = TT_4203;
    }

    // ======================================================
    // CASE 3
    // FULL HEAT EXCHANGING MODE
    // ======================================================

    else {

    // ======================================================
    // COOLING EFFICIENCY
    // ======================================================

    /*
        MORE WATER FLOW
        +
        LOWER GAS FLOW
        =
        BETTER COOLING
    */

    let coolingEfficiency =
        (FIC_4203 / (FIC_4201_EFFECTIVE + 1)) * 0.65;

    // ======================================================
    // LIMIT EFFICIENCY
    // ======================================================

    if (coolingEfficiency > 0.75)
        coolingEfficiency = 0.75;

    if (coolingEfficiency < 0.10)
        coolingEfficiency = 0.10;

    // ======================================================
    // TEMPERATURE DIFFERENCE
    // ======================================================

    const deltaT =
        TT_4201 - TT_4203;

    // ======================================================
    // GAS TEMPERATURE DROP
    // ======================================================

    const gasTemperatureDrop =
        deltaT * coolingEfficiency;

    // ======================================================
    // GAS OUTLET TEMPERATURE
    // ======================================================

    TT_4202 =
        TT_4201*0.7 - gasTemperatureDrop;

    // ======================================================
    // REALISTIC MINIMUM COOLING LIMIT
    // ======================================================

    /*
        Offshore gas coolers rarely
        cool below 50°C in this service
    */

    if (TT_4202 < 50)
        TT_4202 = 50 * 0.68;

    // ======================================================
    // WATER HEATING
    // ======================================================

    const waterTemperatureRise =
        gasTemperatureDrop * 0.35;

    TT_4204 =
        TT_4203 + waterTemperatureRise;

    // ======================================================
    // PRESSURE DROPS
    // ======================================================

    /*
        Typical exchanger pressure losses
    */

    PT_4202 =
        PT_4201 * 0.9;

    PT_4204 =
        PT_4203 * 0.98;

    // ======================================================
    // FLOW LOSSES
    // ======================================================

    FIC_4202 =
        FIC_4201_EFFECTIVE * 0.995;

    FIC_4204 =
        FIC_4203 * 0.998;
    }

    // ======================================================
    // OPTIONAL LOCAL STORAGE
    // ======================================================

    localStorage.setItem("FIC_4202", FIC_4202);
    localStorage.setItem("PT_4202", PT_4202);
    localStorage.setItem("TT_4202", TT_4202);

    localStorage.setItem("FIC_4204", FIC_4204);
    localStorage.setItem("PT_4204", PT_4204);
    localStorage.setItem("TT_4204", TT_4204);


    const PT_4205 = PT_4202*0.8;
    const TT_4205 = TT_4202*0.9;
    const FIC_4205 = FIC_4202*0.99;

    const PT_4206 = isXV4203Open ? 0.8 : 0.03;
    const FIC_4206 = isXV4203Open ? 7.43 : 0;


    useEffect(() => {
        localStorage.setItem("PT_4205", PT_4205);
        }, [PT_4205]);
    
    useEffect(() => {
        localStorage.setItem("TT_4205", TT_4205);
        }, [TT_4205]);
    
    useEffect(() => {
        localStorage.setItem("FIC_4205", FIC_4205);
        }, [FIC_4205]);
    
 


  return (
    <div className="PreDehydCooler-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "220px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 300px"
      }}>
        PRE-DEHYDRATION GAS COOLER
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-4201"
        tag="XV_4201"
        x={343}
        y={102}
        isClosed={valves.XV_4201}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-4202 */}
      <Valve
        className="XV-4202"
        tag="XV_4202"
        x={128}
        y={452}
        isClosed={valves.XV_4202}
        toggle={toggleValve}
      />

      {/* XV-4203 */}
      <Valve
        className="XV-4203"
        tag="XV_4203"
        x={965}
        y={538}
        isClosed={valves.XV_4203}
        toggle={toggleValve}
      />

      
      
      
        

        
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-4201 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-4201"
          style={{ position: "absolute", left: 602, top: 329}}  onClick={() => openPanel("FCV_4201")}>
          
          <defs>
            <linearGradient id="metal_4201">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_4201)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_4201)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

        

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_4201?.opening || 0)}
        x={624}
        y={379}
      />


          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      <Transmitter
        tag="FIC-4201"
        value={[FIC_4201]}
        x={206}
        y={187}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS FROM H2S SCAVENGER VESSEL TO PRE-DEHYDRATION GAS COOLER"
      />

      <Transmitter
        tag="PT-4201"
        value={[PT_4201]}
        x={206}
        y={137}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS FROM H2S SCAVENGER VESSEL TO PRE-DEHYDRATION GAS COOLER"
      />
      
      <Transmitter
        tag="TT-4201"
        value={[TT_4201]}
        x={206}
        y={165}
        unit="°C"
        max={100}
        HH={90}
        H={80}
        L={14}
        LL={5}
        c="lime"
        description="TEMPERATURE OF GAS FROM H2S SCAVENGER VESSEL TO PRE-DEHYDRATION GAS COOLER"
      />


      <Transmitter
        tag="FIC-4202"
        value={[FIC_4202]}
        x={206}
        y={342}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF DEHYDRATION FEED GAS COOLER"
      />

      <Transmitter
        tag="PT-4202"
        value={[PT_4202]}
        x={206}
        y={287}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS AT THE DISCHARGE OF DEHYDRATION FEED GAS COOLER"
      />
      
      <Transmitter
        tag="TT-4202"
        value={[TT_4202]}
        x={206}
        y={315}
        unit="°C"
        max={100}
        HH={90}
        H={80}
        L={14}
        LL={5}
        c="lime"
        description="TEMPERATURE OF GAS AT THE DISCHARGE OF DEHYDRATION FEED GAS COOLER"
      />



      <Transmitter
        tag="FIC-4205"
        value={[FIC_4205]}
        x={1080}
        y={187}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE OVERHEAD OF DEHYDRATION FEED GAS K. O. DRUM"
      />

      <Transmitter
        tag="PT-4205"
        value={[PT_4205]}
        x={1080}
        y={137}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS AT THE OVERHEAD OF DEHYDRATION FEED GAS K. O. DRUM"
      />
      
      <Transmitter
        tag="TT-4205"
        value={[TT_4205]}
        x={1080}
        y={165}
        unit="°C"
        max={100}
        HH={90}
        H={80}
        L={14}
        LL={5}
        c="lime"
        description="TEMPERATURE OF GAS AT THE OVERHEAD OF DEHYDRATION FEED GAS K. O. DRUM"
      />

      <Transmitter
        tag="FIC-4206"
        value={[FIC_4206]}
        x={1180}
        y={601}
        unit="LPM"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CONDENCED FLUID AT THE BOTTOM OF DEHYDRATION FEED GAS K. O. DRUM"
      />

      <Transmitter
        tag="PT-4206"
        value={[PT_4206]}
        x={1180}
        y={573}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF CONDENCED FLUID AT THE BOTTOM OF DEHYDRATION FEED GAS K. O. DRUM"
      />










      
      <Transmitter
        tag="TT-4203"
        value={[TT_4203]}
        x={326}
        y={446}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER FROM FRESH WATER SUPPLY TO DEHYDRATION FEED GAS COOLER FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="PT-4203"
        value={[PT_4203]}
        x={446}
        y={446}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF WATER FROM FRESH WATER SUPPLY TO DEHYDRATION FEED GAS COOLER FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="FIC-4203"
        value={[FIC_4203]}
        x={216}
        y={446}
        unit="LPM"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER FROM FRESH WATER SUPPLY TO DEHYDRATION FEED GAS COOLER FOR HEAT EXCHANGING WITH GAS"
      />


      <Transmitter
        tag="FIC-4204"
        value={[FIC_4204]}
        x={526}
        y={88}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER AT THE DISCHARGE OF DEHYDRATION FEED GAS COOLER"
      />
      
      <Transmitter
        tag="TT-4204"
        value={[TT_4204]}
        x={629}
        y={88}
        unit="°C"
        max={100}
        HH={90}
        H={80}
        L={14}
        LL={5}
        c="lime"
        description="TEMPERATURE OF WATER AT THE DISCHARGE OF DEHYDRATION FEED GAS COOLER"
      />


      <LevelTransmitterIndicator
      tag="LT_4201"
      totalLevel={40000}
      inflows={[FIC_4202 * 0.08]}
      outflows={[FIC_4206]}
      responseFactor={0.05}
      columnX={826}
      columnY={348}
      columnWidth={99}
      columnHeight={200}
      textX={729}
      textY={409}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />

      



      
       

    </div>
  );
}


export default PreDehydCooler;